<md-card class="stb-scheduling" *ngIf="vm.eventsFetched">
    <h3>{{ 'Calendar.Title.Schedule' | translate }}</h3>
    <div class="calendar-legend">
        <div class="legend-item">
            <span class="legend-color legend-grey"></span>
            <span class="legend-text"> - {{ 'Calendar.Other.Past_Times' | translate }}</span>
        </div>
        <div class="legend-item">
            <span class="legend-color legend-yellow"></span>
            <span class="legend-text"> - {{ 'Calendar.Other.Delay_Time' | translate }}</span>
        </div>
    </div>
    <div class="u-ost-xxl u-osl-xl u-osr-xl u-hidden@md-and-up" style="padding-top: 20px;">
        <item-notification icon="attention" [text]="'Calendar.Title.Schedule_Tap_And_Hold' | translate" [theme]="5"></item-notification>
    </div>
    <div class="fc-button-group fc custom-buttons">
        <button class="fc-button save" id="calendarSaveButton" (click)="vm.redirect('/schedule')">{{'Calendar.Button.Save' | translate}}</button>
    </div>
    <ui-calendar id="calendar" class="stb-schedule--calendar" 
       	*ngIf="vm.scheduleLoaded"
       	[calendarId]="'scheduleCalendarConf'" 
        [uiConfig]="vm.uiConfig.calendarConf"
        [eventSources]="events">
    </ui-calendar>
</md-card>
